import { cx } from '@endurancewarranty/ui';

import type { FC, ReactNode } from 'react';

type Props = Readonly<{
  children: ReactNode;
}>;

// Applied to a dialog panel that renders no close button, or to a header row to stop the inset
// from applying twice to a header row nested inside it.
export const MODAL_HEADER_INSET_RESET = '**:data-modal-header-row:pr-0';

// The dialog close button is pinned to the panel's top-right corner, so the header keeps that
// corner clear instead of being pushed below it: pr-12 covers the 40px button plus its 16px
// offset, less the panel's own 20px padding.
export const ModalHeaderRow: FC<Props> = ({ children }) => (
  <div data-modal-header-row="true" className={cx('pr-12', MODAL_HEADER_INSET_RESET)}>
    {children}
  </div>
);
